// extracted by mini-css-extract-plugin
export default {"subtitle":"forgetPassword_subtitle__hjWUy"};